module.exports = __webpack_public_path__ + "AW.png?f35b876bf760c7d28b2b4e29c0c1e5e7";